export default __webpack_public_path__ + "static/media/19.0d54d5e5.png";